/**
 * Featured Collection — Horizontal Scroll
 * Mirror of the featured-blog hscroll logic:
 *   - Collapsing/emerging arrows (Brainmarket style)
 *   - Scrolls to the next card's edge (a snap point) per click
 *   - Arrows swap: right visible initially, left appears after scrolling
 *   - Works with Shopify theme editor re-renders
 */
(function () {
  const SELECTOR = '[data-featured-collection-hscroll]';

  function init(root) {
    if (!root) return;

    // Avoid double binding
    if (root.dataset.hscrollInit === '1') return;
    root.dataset.hscrollInit = '1';

    const scroller = root.querySelector('[data-hscroll]');
    const prev = root.querySelector('.featured-collection__hscroll-arrow--prev');
    const next = root.querySelector('.featured-collection__hscroll-arrow--next');

    if (!scroller || !prev || !next) return;

    // Ensure horizontal scroll is possible
    scroller.style.overflowX = 'auto';

    const amount = () => Math.max(200, Math.floor(scroller.clientWidth * 0.9));

    /**
     * A ~90% page step, rounded to the nearest card edge.
     *
     * WHY NOT scrollBy(amount()) ALONE. The track is `scroll-snap-type: x
     * mandatory` (featured-collection.css) and its children are
     * `scroll-snap-align: start`. 90% of the viewport is an arbitrary number
     * that essentially never coincides with a card edge, so each click animated
     * smoothly to a position between two snap points and the browser then
     * yanked it onto the nearest one — the jolt at the end of every click.
     *
     * The STEP is deliberately unchanged: a page per click is this carousel's
     * design, and moving one card instead would make ten products a chore. Only
     * the landing is corrected — aim at the card edge closest to where the old
     * code was already going, so the snap engine has nothing left to do.
     */
    const edgeTarget = (forward) => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      const desired = Math.max(0, Math.min(max,
        scroller.scrollLeft + (forward ? amount() : -amount())));
      const kids = scroller.children;
      if (!kids.length) return desired;
      const left = scroller.getBoundingClientRect().left;
      let best = desired;
      let bestDist = Infinity;
      for (let i = 0; i < kids.length; i++) {
        const edge = scroller.scrollLeft + (kids[i].getBoundingClientRect().left - left);
        if (edge < -1 || edge > max + 1) continue;
        const dist = Math.abs(edge - desired);
        if (dist < bestDist) { bestDist = dist; best = edge; }
      }
      // The very end of the track is a legitimate stop even mid-card.
      if (Math.abs(max - desired) < bestDist) best = max;
      return Math.max(0, Math.min(max, best));
    };

    // Helper: check if we can still scroll right
    const canScrollRight = () =>
      Math.ceil(scroller.scrollLeft + scroller.clientWidth) < scroller.scrollWidth - 2;

    const canScrollLeft = () => scroller.scrollLeft > 2;

    // ---- UPDATE ARROWS based on scroll position ----
    function updateArrows() {
      const left = canScrollLeft();
      const right = canScrollRight();

      if (left && prev.classList.contains('is-hidden')) {
        prev.classList.remove('is-hidden');
        prev.classList.add('pop-in');
        setTimeout(() => prev.classList.remove('pop-in'), 400);
      } else if (!left && !prev.classList.contains('is-hidden')) {
        prev.classList.add('is-hidden');
      }

      if (right && next.classList.contains('is-hidden')) {
        next.classList.remove('is-hidden');
        next.classList.add('pop-in');
        setTimeout(() => next.classList.remove('pop-in'), 400);
      } else if (!right && !next.classList.contains('is-hidden')) {
        next.classList.add('is-hidden');
      }
    }

    // ---- INITIAL STATE ----
    prev.classList.add('is-hidden');
    if (!canScrollRight()) {
      next.classList.add('is-hidden');
    } else {
      next.classList.remove('is-hidden');
    }

    // ---- NEXT CLICK ----
    next.addEventListener('click', function (e) {
      e.preventDefault();
      scroller.scrollTo({ left: edgeTarget(true), behavior: 'smooth' });

      // Wait for scroll to settle, then update arrows
      setTimeout(updateArrows, 350);
    });

    // ---- PREV CLICK ----
    prev.addEventListener('click', function (e) {
      e.preventDefault();
      scroller.scrollTo({ left: edgeTarget(false), behavior: 'smooth' });

      // Watch until scroll settles
      var last = -1;
      var stableFrames = 0;

      function watch() {
        var x = scroller.scrollLeft;

        if (Math.abs(x - last) < 0.5) stableFrames += 1;
        else stableFrames = 0;

        last = x;

        if (x <= 2 || stableFrames >= 6) {
          updateArrows();
          return;
        }

        requestAnimationFrame(watch);
      }

      requestAnimationFrame(watch);
    });

    // ---- Also update on manual scroll / touch swipe ----
    var scrollTimer;
    scroller.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateArrows, 100);
    }, { passive: true });
  }

  function boot(context) {
    var scope = context || document;
    scope.querySelectorAll(SELECTOR).forEach(init);
  }

  // Normal load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Theme editor: section re-render
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
